import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { Link, useNavigate } from "react-router-dom";
import { IMG_SERVER_URL } from "../utils/constant";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Img from "../components/Img";
import axios from "axios";
import { getAxiosConfig, getUpdatedImageUrlWithSize } from "../utils/helpers";
import { Icon } from "@iconify/react/dist/iconify.js";

const Trending = () => {
  const [images, setImages] = useState([]);
  const [popupImage, setPopupImage] = useState(null);
  const [currPage, setCurrPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  async function fetchImages() {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/image/trending`,
        getAxiosConfig({
          page: currPage,
          limit: 20,
        }),
      );
      console.log("Trending Images", data);
      if (data.data.length < 20) {
        setHasMore(false);
      }
      setImages((p) => [...p, ...data.data]);
    } catch (error) {
      console.error("Error fetching trending images:", error);
    }
  }
  useEffect(() => {
    hasMore && fetchImages();
  }, [currPage]);

  useEffect(() => {
    const handleScroll = (e) => {
      const screenHeight = window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;
      const scrollTop = document.documentElement.scrollTop;
      if (screenHeight + scrollTop + 1 >= totalHeight) {
        setCurrPage((p) => p + 1);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);
  // console.log({ hasMore, currPage });
  return (
    <Layout>
      <div className="container mx-auto p-3 lg:px-20">
        <h1 className="text-3xl text-center font-semibold mb-5">
          Best of Workspace Trendings
        </h1>
        {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7 my-5"> ... */}
        <ResponsiveMasonry
          columnsCountBreakPoints={{ 350: 1, 600: 2, 950: 3, 1100: 4 }}
        >
          <Masonry gutter={"1.2rem"}>
            {images.map((image, index) => (
              <div
                key={index}
                onClick={() => setPopupImage(image)}
                className="hover:scale-[1.05] transform transition duration-500 relative cursor-pointer"
              >
                <Img
                  className="relative item rounded-xl w-full h-full min-h-[200px]"
                  src={getUpdatedImageUrlWithSize(
                    `${IMG_SERVER_URL}/brick-img/${image._id}.jpg`,
                    [1, 1, 2],
                  )}
                  alt="Image"
                />
                {/* Eye icon and click count */}
                <div className="absolute top-2 right-2 bg-black/60 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-1 text-white text-xs shadow">
                  <span className="inline-flex items-center">
                    <Icon icon="mdi:eye-outline" width={18} className="mr-1" />
                    {image.clicks || 0}
                  </span>
                </div>
              </div>
            ))}
          </Masonry>
        </ResponsiveMasonry>
        {/* Image Popup Modal */}
        {popupImage && (
          <div
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60"
            onClick={() => setPopupImage(null)}
          >
            <div
              className="relative bg-white rounded-xl shadow-xl p-4 max-w-2xl w-full  flex flex-col items-center"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-primary-500 text-2xl"
                onClick={() => setPopupImage(null)}
              >
                &times;
              </button>
              {/* <div className="max-h-[70svh]"> */}
              <Img
                src={getUpdatedImageUrlWithSize(
                  `${IMG_SERVER_URL}/brick-img/${popupImage._id}.jpg`,
                  [2, 2, 3],
                )}
                alt="Popup"
                className="max-h-[70vh] min-h-[200px] h-full w-auto rounded-lg mb-2"
              />
              {/* </div> */}
              <div className="flex items-center gap-2 text-gray-700 text-sm">
                <Icon icon="mdi:eye-outline" width={18} />
                {popupImage.clicks || 0} views
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Trending;
